import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { AddComboTopping, ComboToppingItem, RemoveComboTopping } from './comboTopping.types';

export const useComboTopping = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<ComboToppingItem[]>>({
    queryKey: 'comboTopping',
    queryFn: () => apiClient.get<ComboToppingItem[]>('/combo-toppings'),
    enabled,
  });
};

export const useAddNewComboTopping = () => {
  return useMutation((record: AddComboTopping) => {
    return apiClient.post(`/combo-toppings/`, record);
  });
};

export const useRemoveComboTopping = () => {
  return useMutation((requestBody: RemoveComboTopping[]) => {
    return apiClient.delete(`/combo-toppings/`, { data: requestBody });
  });
};
